/**
 * Translations.
 */
export default {
  ACTION: {
    LINK_COPY: 'Copiar'
  },
  ERROR: {},
  HEADER: {
    NAME: 'Nome'
  },
  LABEL: {
    FILTER_MONTH_APR: 'Abril',
    FILTER_MONTH_AUG: 'Agosto',
    FILTER_MONTH_DEC: 'Dezembro',
    FILTER_MONTH_FEB: 'Fevereiro',
    FILTER_MONTH_JAN: 'Janeiro',
    FILTER_MONTH_JUL: 'Julho',
    FILTER_MONTH_JUN: 'Junho',
    FILTER_MONTH_MAR: 'Março',
    FILTER_MONTH_MAY: 'Maio',
    FILTER_MONTH_NOV: 'Novembro',
    FILTER_MONTH_OCT: 'Outubro',
    FILTER_MONTH_SEP: 'Setembro',
    GENERATE_HASHTAG: 'Gerar hashtag',
    GENERATE_LINK: 'Gerar link',
    GENERATED_HASHTAG: 'Hashtag gerado',
    GENERATED_LINK: 'Link gerado',
    MONTH: 'Mês',
    NAME: 'Nome',
    YEAR: 'Ano'
  },
  SENTENCE: {
    NO_ROWS_PRODUCTS: 'Sem produtos',
    NO_ROWS_PRODUCTS_DESCRIPTION: 'Altere os critérios de pesquisa'
  },
  SUCCESS: {
    HASHTAG_COPIED: 'Hashtag copiada',
    LINK_COPIED: 'Link copiado'
  },
  TOOLTIP: {
    MONTH: 'Mês',
    NAME: 'Nome',
    YEAR: 'Ano'
  }
};
